// extracted by mini-css-extract-plugin
var _1 = "PostViewBanner-module__animateUploadProgressBarWidth--v0sMj";
var _2 = "PostViewBanner-module__animatedBackground--cIqIA";
var _3 = "PostViewBanner-module__banner--Cw3LH";
var _4 = "PostViewBanner-module__container--ZLhfb";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "banner", _4 as "container" }
